import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V8.79289L10.9798 6.31311C11.175 6.11785 11.4916 6.11785 11.6869 6.31311C11.8821 6.50838 11.8821 6.82496 11.6869 7.02022L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L4.31311 7.02022C4.11785 6.82496 4.11785 6.50838 4.31311 6.31311C4.50838 6.11785 4.82496 6.11785 5.02022 6.31311L7.5 8.79289V2C7.5 1.72386 7.72386 1.5 8 1.5ZM2 9.5C2.27614 9.5 2.5 9.72386 2.5 10V10.8C2.5 11.3683 2.50039 11.7645 2.52559 12.0729C2.55031 12.3755 2.5964 12.5493 2.66349 12.681C2.8073 12.9632 3.03677 13.1927 3.31901 13.3365C3.45069 13.4036 3.62454 13.4497 3.92712 13.4744C4.23554 13.4996 4.6317 13.5 5.2 13.5H10.8C11.3683 13.5 11.7645 13.4996 12.0729 13.4744C12.3755 13.4497 12.5493 13.4036 12.681 13.3365C12.9632 13.1927 13.1927 12.9632 13.3365 12.681C13.4036 12.5493 13.4497 12.3755 13.4744 12.0729C13.4996 11.7645 13.5 11.3683 13.5 10.8V10C13.5 9.72386 13.7239 9.5 14 9.5C14.2761 9.5 14.5 9.72386 14.5 10V10.8214C14.5 11.3633 14.5 11.8004 14.4711 12.1543C14.4413 12.5187 14.3784 12.8388 14.2275 13.135C13.9878 13.6054 13.6054 13.9878 13.135 14.2275C12.8388 14.3784 12.5187 14.4413 12.1543 14.4711C11.8004 14.5 11.3633 14.5 10.8214 14.5H5.17858C4.6367 14.5 4.19963 14.5 3.84569 14.4711C3.48126 14.4413 3.16117 14.3784 2.86502 14.2275C2.39462 13.9878 2.01217 13.6054 1.77248 13.135C1.62159 12.8388 1.55868 12.5187 1.52891 12.1543C1.49999 11.8004 1.5 11.3633 1.5 10.8214L1.5 10C1.5 9.72386 1.72386 9.5 2 9.5Z"
        fill="#6E00BE"
      />
    </svg>
  );
};

export default DownloadIcon;
